import { cn } from "@/lib/utils";
import type { Dispatch, SetStateAction } from "react";
import { SetValueType } from "./new-email-dialog";

export const CCBCCOptions = ({
  setCc,
  setBcc,
  setValue,
  cc,
  bcc,
}: {
  setCc: Dispatch<SetStateAction<boolean>>;
  setBcc: Dispatch<SetStateAction<boolean>>;
  setValue: SetValueType,
  cc: boolean,
  bcc: boolean,
}) => {
  return (
    <div className="flex gap-1 self-start text-muted-foreground">
      <button
        type="button"
        onClick={() =>
          setCc((prev) => {
            if (prev) {
              setValue("cc", []);
            }
            return !prev;
          })
        }
        className={cn("px-1", cc && "text-primary bg-primary/10 rounded-sm")}
      >
        Cc
      </button>
      <button
        type="button"
        onClick={() =>
          setBcc((prev) => {
            if (prev) {
              setValue("bcc", []);
            }
            return !prev;
          })
        }
        className={cn("px-1", bcc && "text-primary bg-primary/10 rounded-sm")}
      >
        Bcc
      </button>
    </div>
  );
};
